interface SkeletonProps {
  width?: number | string
  height?: number
  radius?: number
}

export function Skeleton({ width = '100%', height = 14, radius }: SkeletonProps) {
  return <span className="skeleton" style={{ width, height, borderRadius: radius }} aria-hidden="true" />
}

/** Заглушка списка задач, пока грузится. */
export function SkeletonList({ rows = 4 }: { rows?: number }) {
  const widths = ['82%', '64%', '90%', '58%', '76%', '70%']
  return (
    <div className="section__body" role="status" aria-busy="true" aria-label="Загрузка">
      {widths.slice(0, rows).map((w) => (
        <div key={w} className="cell" style={{ alignItems: 'flex-start', minHeight: 64 }}>
          <Skeleton width={22} height={22} radius={11} />
          <span className="cell__main" style={{ gap: 8 }}>
            <Skeleton width={w} height={16} />
            <Skeleton width="38%" height={12} />
          </span>
        </div>
      ))}
    </div>
  )
}

export function SkeletonBlock({ lines = 3 }: { lines?: number }) {
  const widths = ['92%', '74%', '86%', '60%', '80%']
  return (
    <div className="card" role="status" aria-busy="true" aria-label="Загрузка">
      {widths.slice(0, lines).map((w) => (
        <Skeleton key={w} width={w} height={14} />
      ))}
    </div>
  )
}
